import { RouteObject } from 'react-router-dom';
import ListBeltResponsive from "../components/ResponsiveWrapper/Belt/ListBeltResponsive";
import ListBelts, { loader as ListBeltsLoader } from "../pages/ListBelts";
import SingleBeltResponsive from "../components/ResponsiveWrapper/Belt/SingleBeltResponsive";
import BeltHallOfFame, { loader as BeltHallOfFameLoader } from "../pages/BeltHallOfFame";
import TagBeltResponsive from "../components/ResponsiveWrapper/Belt/TagBeltResponsive";
import { TagBeltHallOfFameLoader } from "../loaders/TagBeltHallOfFameLoader";

export const beltsRoutes: RouteObject = {
  path: 'belts',
  children: [
    {
      index: true,
      element: <ListBeltResponsive />,
      loader: ListBeltsLoader
    },
    {
      path: ':id/hall-of-fame',
      element: <SingleBeltResponsive />,
      loader: BeltHallOfFameLoader
    },
    {
      path: 'tag/:id/hall-of-fame',
      element: <TagBeltResponsive />,
      loader: TagBeltHallOfFameLoader
    },
  ]
};
